<template>
  <div>
    <div class="mt-order-top" style="height: auto;">
      <el-form :inline="true" :model="searchForm" class="demo-form-inline">
        <el-form-item label="订单搜索：">
          <el-input v-model="searchForm.name" placeholder="请输入订单号/用户昵称/手机号搜索" class="mt-search-width"></el-input>
        </el-form-item>
        <el-form-item label="订单类型：">
          <el-select v-model="searchForm.deliveryType" placeholder="请选择" class="mt-search-width">
            <el-option
              v-for="item in deliveryTypeArr"
              :key="item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="时间筛选：">
          <el-date-picker
            v-model="searchForm.date"
            :picker-options="pickerOptions"
            :clearable="false"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="支付时间：">
          <el-date-picker
            v-model="searchForm.datePay"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="完成时间：">
          <el-date-picker
            v-model="searchForm.dateComplete"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期">
          </el-date-picker>
        </el-form-item>
        <el-form-item label="商品搜索：">
          <el-input v-model="searchForm.goodsName" placeholder="请输入商品名称搜索" class="mt-search-width"></el-input>
        <el-button type="primary" style="margin-left: 12px;" @click="searchTopBtn">查询</el-button>
        </el-form-item>
      </el-form>
      <!-- <el-button v-loading.fullscreen.lock="fullscreenLoading">批量发货</el-button> -->
      <el-button @click="exportExcelBtn" v-loading.fullscreen.lock="fullscreenLoading">数据导出</el-button>
      <el-button @click="toOrderEntry">订单录入</el-button>
    </div>
    <div>
      <el-table
        :data="infoList"
        style="width: 100%">
        <el-table-column
          align="center"
          prop="orderNo"
          label="订单号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realName"
          label="昵称">
        </el-table-column>
        <el-table-column
          align="center"
          prop="phone"
          label="手机号">
        </el-table-column>
        <el-table-column
          align="center"
          prop="deliveryType"
          label="订单类型">
          <template slot-scope="scope">
            <span>{{scope.row.deliveryType == 1 ? '自提订单' : scope.row.deliveryType == 2 ? '同城配送' : '配送订单'}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          prop="goodsOrderGoodsList"
          width="450"
          label="商品信息">
          <template slot-scope="scope">
            <div class="" v-for="(item,index) in scope.row.goodsOrderGoodsList" :key="index">
              <el-image
                style="width: 32px;"
                :src="item.thumb"
                :preview-src-list="[item.thumb]"
                fit="contain">
                </el-image>
                <span>{{item.goodsName}}-{{item.specName}}</span>
                <span>x{{item.goodsNumber}}</span>
            </div>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderMoney"
          label="订单金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="realPayMoney"
          label="支付金额">
        </el-table-column>
        <el-table-column
          align="center"
          prop="paySuccessTimeStr"
          label="支付时间">
        </el-table-column>
        <el-table-column
          align="center"
          prop="overTime"
          label="完成时间">
          <template slot-scope="scope">
            <span>{{scope.row.overTime == null ? '--' : scope.row.overTime}}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="orderStatus"
          label="订单状态">
          <template slot-scope="scope">
            <span v-if="scope.row.orderStatus === 0 && tabCurrent !== 4" style="color: #FF5733;">待支付</span>
            <span v-if="scope.row.orderStatus === 1 && tabCurrent !== 4" style="color: #FF5733;">
              待发货 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}
            </span>
            <span v-if="scope.row.orderStatus === 2 && tabCurrent !== 4" style="color: #E6A23C;">{{scope.row.deliveryType == 1 ? '待核销' : '待收货'}} {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 3 && tabCurrent !== 4" style="color: #999999;">{{scope.row.deliveryType == 1 ? '已核销' : '已完成'}} {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="tabCurrent === 4" style="color: #FF5733;">待评价 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 4" style="color: #999999;">已关闭 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 5" style="color: #FF5733;">拼团中 {{scope.row.isPartiallyRefunded == 1 ? '[部分退款]' : ''}}</span>
            <span v-if="scope.row.orderStatus === 91" style="color: #E6A23C;">已退款</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          prop="refundMoney"
          label="退款金额">
        </el-table-column>
        <el-table-column
          fixed="right"
          align="center"
          width="240"
          label="操作">
          <template slot-scope="scope">
            <el-button type="text" size="small" @click="detailOpenBtn(scope.row.id)">详情</el-button>
            <el-button style="display: none;" v-if="scope.row.orderStatus == 1 && scope.row.deliveryType == 0" @click="sendOpenBtn(scope.row.id)" type="text" size="small">发货</el-button>
            <el-button v-if="scope.row.orderStatus == 1 && scope.row.deliveryType == 2" @click="sendOpenBtn(scope.row.id)" type="text" size="small">发货</el-button>
            <el-button v-if="scope.row.orderStatus == 2 && scope.row.deliveryType == 1" @click="writeOffBtn(scope.row.id)" v-loading.fullscreen.lock="fullscreenLoading" type="text" size="small">核销</el-button>
            <el-button v-if="scope.row.orderStatus == 2 && scope.row.deliveryType == 0" @click="watchWlBtn(scope.row.id)" type="text" size="small">查看物流</el-button>
            <el-button v-if="scope.row.showChangeDeliveryButton == 1" @click="changeSendOpenBtn(scope.row.id)" type="text" size="small">变更配送</el-button>
        </template>
        </el-table-column>
      </el-table>
      <div class="mt-page-bottom flex-end-row">
        <pagination :total="pageTotal" :page="currentPage" :limit="limitLength" @pagination="paginationChangeBtn" />
      </div>
    </div>
    <!-- 订单详情弹窗 -->
    <el-drawer
      size="960px"
      :visible.sync="detailShow"
      :with-header="false">
      <order-detail :infoId="infoId" @sendOrderInfo="sendOrderGetValue"></order-detail>
    </el-drawer>
    <!-- 订单发货弹窗 -->
    <el-dialog
      title="订单发货"
      :visible.sync="sendOrderShow"
      width="960px">
      <order-send :infoId="infoId" :goodsData="goodsData" @sendOrderSave="sendOrderSaveGetValue" @sendGoodsData="sendGoodsGetValue"></order-send>
    </el-dialog>
    <!-- 选择商品弹窗 -->
    <el-dialog
      title="选择商品"
      :visible.sync="goodsListShow"
      width="960px">
      <goods-list :infoId="infoId" @choosedGoodsData="choosedGoodsDataGetValue"></goods-list>
    </el-dialog>
    <!-- 查看物流弹窗 -->
    <el-drawer
      :with-header="false"
      :visible.sync="wlOrderShow"
      size="960px">
      <order-wl v-if="wlOrderShow" :infoId="infoId"></order-wl>
    </el-drawer>
    <!-- 订单变更配送方式弹窗 -->
    <el-dialog
      title="变更配送方式"
      :visible.sync="changeSendShow"
      size="960px">
      <el-form :model="changeSendForm" ref="changeSendForm" label-width="190px" size="small" class="demo-ruleForm">
        <el-form-item label="收货类型：" prop="deliveryType">
          <el-radio-group v-model="changeSendForm.deliveryType">
            <el-radio :label="0">快递配送</el-radio>
            <el-radio :label="1">自提</el-radio>
            <el-radio :label="2">同城配送</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 0 || changeSendForm.deliveryType === 2" label="收货人名称：">
          <el-input style="width: 420px;" v-model="changeSendForm.realName" placeholder="请输入收货人名称"></el-input>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 0 || changeSendForm.deliveryType === 2" label="收货人电话：">
          <el-input style="width: 420px;" v-model="changeSendForm.phone" placeholder="请输入收货人电话"></el-input>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 0 || changeSendForm.deliveryType === 2" label="选择省市区：">
            <el-cascader
            ref="cascader"
            style="width: 420px;"
            v-model="addressIds"
            :options="addressList"
            @change="changeSendHandleChange"
            :props="{ value: 'value',label: 'text',children: 'children'}"></el-cascader>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 0 || changeSendForm.deliveryType === 2" label="详细地址：">
          <el-input style="width: 420px;" v-model="detailTxt" placeholder="请输入详细地址"></el-input>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 2" label="经度：" prop="latitude">
          <el-input style="width: 420px;" v-model="changeSendForm.latitude" placeholder="请输入经度"></el-input>
          <a class="color-theme" style="display: inline-block;" href="https://lbs.qq.com/tool/getpoint/index.html" target="_blank">点击获取</a>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 2" label="纬度：" prop="longitude">
          <el-input style="width: 420px;" v-model="changeSendForm.longitude" placeholder="请输入纬度"></el-input>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 0" label="物流公司：">
          <el-input style="width: 420px;" v-model="changeSendForm.sendCompany" placeholder="请输入物流公司"></el-input>
        </el-form-item>
        <el-form-item v-if="changeSendForm.deliveryType === 0" label="物流单号：">
          <el-input style="width: 420px;" v-model="changeSendForm.sendNumber" placeholder="请输入物流单号"></el-input>
        </el-form-item>
        <el-form-item>
          <el-button size="medium" @click="changeSendCloseBtn">取消</el-button>
          <el-button type="primary" size="medium" @click="changeSendSaveBtn" v-loading.fullscreen.lock="fullscreenLoading">确认</el-button>
        </el-form-item>
      </el-form>
    </el-dialog>
  </div>
</template>

<script>
import { orderList, writeOutOrder, orderExportExcel, saveGoodsOrderSend, changeOrderDeliveryType } from '@/api/order'
import { queryAreaTreeList } from '@/api/shop'
import OrderDetail from './Detail.vue'
import OrderSend from './Send.vue'
import GoodsList from './GoodsList.vue'
import OrderWl from './OrderWl.vue'
export default {
  name: 'OrderSingle',
  components: {
    OrderDetail,
    OrderSend,
    GoodsList,
    OrderWl
  },
  props: {
    tabCurrent: {
      type: Number,
      default: 99
    }
  },
  watch: {
    "tabCurrent"(newVal, oldVal) {
      this.currentPage = 1;
      this.getInfoList();
    }
  },
  data () {
    return {
      imgServer: this.$imgServer,
      baseUrl: this.$baseUrl,
      fullscreenLoading: false,
      minDate: null,
      maxDate: null,
      pickerOptions: {
        disabledDate: (time) => {
          if (this.minDate !== null && this.maxDate === null) {
            const minMonth = this.minDate.getMonth();
            const lastYear = new Date(this.minDate).setMonth(minMonth - 11);
            const nextYear = new Date(this.minDate).setMonth(minMonth + 11);
            // 选择时间最多为12个月，并且不能超过今天的日期
            return time.valueOf() < lastYear || time.getTime() > Date.now() || time.valueOf() > nextYear;
          }
          return false;
        },
        onPick: ({ minDate, maxDate }) => {
          this.minDate = minDate;
          this.maxDate = maxDate;
        },
      },
      searchForm: {
        name:'',
        deliveryType:'',
        date:['', ''],
        datePay:['', ''],
        dateComplete:['', ''],
        goodsName:''
      },
      deliveryTypeArr:[{
        value:1,
        label:'自提订单'
      }, {
        value:0,
        label:'配送订单'
      }],
      activeName:'first',
      limitLength: this.$limitLength,
      pageTotal: 0,
      infoList:[],
      currentPage: 1,
      infoId:'',
      // 订单详情
      detailShow:false,
      // 订单发货弹窗
      sendOrderShow:false,
      // 选择商品弹窗
      goodsListShow:false,
      goodsData:[],
      // 查看物流弹窗
      wlOrderShow:false,
      // 订单变更配送方式弹窗
      changeSendShow:false,
      changeSendForm:{
        orderId:'',
        deliveryType: '',
        realName:'',
        phone:'',
        detail:'',
        longitude:'',
        latitude:'',
        sendNumber:'',
        sendCompany:''
      },
      detailTxt:'',
      addressList:[],
      addressIds:[],
      addressTxts:[],
    }
  },
  mounted () {
    var that = this;
    let currentDate = new Date();
    // 获取15天前的日期
    let fifteenDaysAgo = new Date(currentDate);
    fifteenDaysAgo.setDate(fifteenDaysAgo.getDate() - 15);
    let dataArr = [fifteenDaysAgo.toISOString().split('T')[0],currentDate.toISOString().split('T')[0]];
    // that.searchForm.date = dataArr; //（默认时间显示）
    that.getInfoList();
    // 地址列表三级联动
    queryAreaTreeList({}).then((res) => {
        if (res.errorCode === '0000') {
          var data = res.data;
          that.addressList = data;
        }
    })
  },
  methods: {
    /* 取子组件"OrderDetail"传值 */
    sendOrderGetValue(sendOrderShow, infoId){
      if(sendOrderShow == 1){
        this.detailShow = false;
      }
      this.infoId = infoId;
      this.sendOrderShow = true;
    },
    /* 取子组件"OrderSend"传值 */
    sendOrderSaveGetValue(sendOrderShow, infoId){
      if(sendOrderShow == 2){
        this.getInfoList();
      }
      this.infoId = infoId;
      this.sendOrderShow = false;
    },
    /* 取子组件"OrderSend"传值-选择商品 */
    sendGoodsGetValue(goodsListShow, infoId){
      this.infoId = infoId;
      this.goodsListShow = true;
      this.sendOrderShow = false;
    },
    /* 取子组件"GoodsList"传值 */
    choosedGoodsDataGetValue(goodsData){
      this.goodsData = goodsData;
      this.goodsListShow = false;
      this.sendOrderShow = true;
    },
    // 订单变更配送方式弹窗-打开操作
    changeSendOpenBtn(infoId){
      this.changeSendForm.orderId = infoId;
      this.changeSendForm.deliveryType = '';
      this.changeSendForm.realName = '';
      this.changeSendForm.phone = '';
      this.changeSendForm.detail = '';
      this.changeSendForm.longitude = '';
      this.changeSendForm.latitude = '';
      this.changeSendForm.sendCompany = '';
      this.changeSendForm.sendNumber = '';
      this.changeSendShow = true;
    },
     // 订单变更配送方式弹窗-选择省市区操作
    changeSendHandleChange(){
      // 获取选中的节点
      const checkedNodes = this.$refs.cascader.getCheckedNodes()
      
      if (checkedNodes.length > 0) {
        // 获取路径文本（包含所有层级）
        const pathLabels = checkedNodes[0].pathLabels
        // console.log('中文路径:', pathLabels)
        this.addressTxts = pathLabels;
        // 或者获取当前节点的 label
        // const currentLabel = checkedNodes[0].label
        // console.log('当前节点:', currentLabel)
      }
    },
    // 订单变更配送方式弹窗-确认操作
    changeSendSaveBtn(){
      var changeSendForm = this.changeSendForm;
      var detailTxt = this.detailTxt;
      var addressTxts = this.addressTxts;
      if (changeSendForm.deliveryType === ''){
        this.$message.error('请选择收货类型')
          return false;
      }
      if (changeSendForm.deliveryType === 0 || changeSendForm.deliveryType === 2) {
        if(changeSendForm.realName == ''){
          this.$message.error('请输入收货人名称')
          return false;
        }
        if(changeSendForm.phone == ''){
          this.$message.error('请输入收货人电话')
          return false;
        }
        if(addressTxts.length == 0){
          this.$message.error('请选择省市区')
          return false;
        }
        if(detailTxt == ''){
          this.$message.error('请输入详细地址')
          return false;
        }
        changeSendForm.detail = addressTxts[0]+addressTxts[1]+addressTxts[2]+detailTxt;
      }
      if (changeSendForm.deliveryType === 2) {
        if (changeSendForm.latitude === '') {
          this.$message.error('请输入经度')
          return false
        }
        if (changeSendForm.longitude === '') {
          this.$message.error('请输入纬度')
          return false
        }
      }
      if (changeSendForm.deliveryType === 0) {
        if(changeSendForm.sendCompany == ''){
          this.$message.error('请输入物流公司')
          return false;
        }
        if(changeSendForm.sendNumber == ''){
          this.$message.error('请输入物流单号')
          return false;
        }
      }
      var that = this;
      that.fullscreenLoading = true
      changeOrderDeliveryType(changeSendForm).then((res) => {
        that.fullscreenLoading = false
        if (res.errorCode === '0000') {
          this.$message({
            message: res.msg,
            type: 'success',
            onClose () {
              that.$router.go(0)
            }
          })
        }
        if (res.errorCode === '1001') {
          this.$message.error(res.msg)
        }
      })
    },
    // 订单变更配送方式弹窗-关闭操作
    changeSendCloseBtn(infoId){
      this.changeSendForm.orderId = '';
      this.changeSendForm.deliveryType = 0;
      this.changeSendForm.realName = '';
      this.changeSendForm.phone = '';
      this.changeSendForm.detail = '';
      this.changeSendForm.longitude = '';
      this.changeSendForm.latitude = '';
      this.changeSendShow = false;
    },
    // 导出操作
    exportExcelBtn(){
      let that = this
      let deliveryType = that.searchForm.deliveryType
      let searchName = that.searchForm.name
      let goodsName = that.searchForm.goodsName
      let tabCurrent = that.tabCurrent
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let startPaySuccessDate = ''
      let endPaySuccessDate = ''
      if (that.searchForm.datePay !== null) {
        startPaySuccessDate = that.searchForm.datePay[0]
        endPaySuccessDate = that.searchForm.datePay[1]
      }
      let startOverDate = ''
      let endOverDate = ''
      if (that.searchForm.dateComplete !== null) {
        startOverDate = that.searchForm.dateComplete[0]
        endOverDate = that.searchForm.dateComplete[1]
      }
      var passData = {
        webSearchQuery: searchName,
        deliveryType: deliveryType,
        startCreateDate: startDate,
        endCreateDate: endDate,
        startPaySuccessDate: startPaySuccessDate,
        endPaySuccessDate: endPaySuccessDate,
        startOverDate: startOverDate,
        endOverDate: endOverDate,
        orderStatus:tabCurrent,
        goodsName:goodsName
      }
      that.fullscreenLoading = true;
      orderExportExcel(passData).then((res) => {
        that.fullscreenLoading = false;
          // 处理二进制数据并创建 Blob 对象
          const blobObj = new Blob([res], { type: 'application/octet-stream' });
          // 创建一个链接并设置下载属性
          const downloadLink = document.createElement("a");
          let url = window.URL || window.webkitURL || window.moxURL; // 兼容不同浏览器的 URL 对象
          url = url.createObjectURL(blobObj);
          downloadLink.href = url;
          downloadLink.download = '订单列表'+new Date().getTime()+'.xlsx'; // 设置下载的文件名
          // 将链接添加到 DOM 中，模拟点击
          document.body.appendChild(downloadLink);
          downloadLink.click();
          // 移除创建的链接和释放 URL 对象
          document.body.removeChild(downloadLink);
          window.URL.revokeObjectURL(url);
      })
    },
    // 发货弹窗-打开操作
    sendOpenBtn(infoId){
      this.infoId = infoId;
      // this.goodsData = [];
      // this.sendOrderShow = true;
      var that = this;
      that.$confirm('是否确认发货？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        that.fullscreenLoading = true
        saveGoodsOrderSend({ orderId: infoId}).then((res) => {
          that.fullscreenLoading = false
          if (res.errorCode === '0000') {
            that.$message({
              message: res.msg,
              type: 'success',
              onClose () {
                that.getInfoList()
              }
            })
          }
          if (res.errorCode === '1001') {
            that.$message.error(res.msg)
          }
        })
      }).catch(() => {})
    },
    /* 查看物流弹窗-打开操作 */
    watchWlBtn(infoId){
      this.infoId = infoId;
      this.wlOrderShow = true;
    },
    /* 打开详情操作 */
    detailOpenBtn(infoId){
      this.infoId = infoId;
      this.detailShow = true;
    },
    /* 核销操作 */
    writeOffBtn(infoId){
      var that = this;
      this.$confirm('是否核销当前选择的商品？', '温馨提示', {
        distinguishCancelAndClose: true,
        confirmButtonText: '确认',
        cancelButtonText: '取消'
      })
        .then(() => {
          // 执行保存相关操作
          that.fullscreenLoading = true;
          writeOutOrder({orderId:infoId}).then((res) => {
            that.fullscreenLoading = false;
            if (res.errorCode === '0000') {
              that.$message.error(res.msg);
              that.getInfoList();
            }
            if (res.errorCode === '1001') {
              that.$message.error(res.msg);
            }
          });
        })
        .catch(action => {
          if(action === 'cancel'){
            // 执行打印相关操作
          }
        });
    },
    /* 跳转订单录入 */
    toOrderEntry () {
      this.$router.push('/order_entry')
    },
    /* 搜索操作 */
    searchTopBtn(){
      this.currentPage = 1;
      this.getInfoList();
    },
    // 获取数据
    getInfoList () {
      let that = this
      let deliveryType = that.searchForm.deliveryType
      let searchName = that.searchForm.name
      let goodsName = that.searchForm.goodsName
      let tabCurrent = that.tabCurrent
      let page = that.currentPage
      let startDate = ''
      let endDate = ''
      if (that.searchForm.date !== null) {
        startDate = that.searchForm.date[0]
        endDate = that.searchForm.date[1]
      }
      let startPaySuccessDate = ''
      let endPaySuccessDate = ''
      if (that.searchForm.datePay !== null) {
        startPaySuccessDate = that.searchForm.datePay[0]
        endPaySuccessDate = that.searchForm.datePay[1]
      }
      let startOverDate = ''
      let endOverDate = ''
      if (that.searchForm.dateComplete !== null) {
        startOverDate = that.searchForm.dateComplete[0]
        endOverDate = that.searchForm.dateComplete[1]
      }
      var passData = {
        webSearchQuery: searchName,
        deliveryType: deliveryType,
        startCreateDate: startDate,
        endCreateDate: endDate,
        pageNum: page,
        pageSize: that.limitLength,
        orderStatus:tabCurrent,
        startPaySuccessDate: startPaySuccessDate,
        endPaySuccessDate: endPaySuccessDate,
        startOverDate: startOverDate,
        endOverDate: endOverDate,
        goodsName:goodsName
      }
      orderList(passData).then((res) => {
        if (res.errorCode === '0000') {
          let data = res.data
          that.infoList = data
          that.pageTotal = res.total
        }
        if (res.errorCode === '4002') {
          that.infoList = []
          that.pageTotal = res.total
        }
      })
    },
    // 分页改变操作
    paginationChangeBtn(val){
      this.currentPage = val.page;
      this.limitLength = val.limit;
      this.getInfoList();
    }
  }
}
</script>

<style>
 .el-header {
    background-color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/pages/order/components/OrderSingle.vue